import type { GatsbyBrowser } from 'gatsby';

import { initLivePreview } from '@cs-reckitt/contentstack-live-preview';

import './src/styles/main.scss';

export const onClientEntry: GatsbyBrowser['onClientEntry'] = () => {
  initLivePreview();
};
